import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetTeamQuery = (teamId: string | null) => {
  const { teamController } = useAvApi();

  return useQuery({
    queryKey: ['team', teamId],
    queryFn: async () => {
      if (!teamId) return null;

      const { data } = await teamController.getV2TeamsByTeamId({
        teamId,
      });

      return data;
    },
  });
};
